<template>
	<div class="spv">
		<div class="spv__elm">
			<!-- ///////////// -->
			<!-- BACKWARD LINK -->
			<div class="spv__elm-backward">
				<div
					v-if="!device.isMobile"
					class="spv__elm-backward-link"
					@click="onClickRedirect('instances')"
				>
					<IconArrowLeft color="rgb(49, 49, 50)" />
				</div>
				<div class="spv__elm-backward-label">Настройки профиля</div>
			</div>

			<!-- //////////////// -->
			<!-- SETTING PROFILE -->
			<SettingProfile />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import { mapGetters } from "vuex";
import SettingProfile from "@/components/profile/SettingProfile.vue";

@Options({
	components: { SettingProfile, IconArrowLeft },

	computed: {
		...mapGetters("instanceModule", {
			device: "getDevice",
		}),
	},
})
export default class SettingProfileView extends Vue {
	// ************************************************************
	// Define mapGetters
	public device: { isMobile: boolean };

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public onClickRedirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}
}
</script>

<style scoped lang="scss">
.spv {
	display: flex;
	justify-content: center;
	user-select: none;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-backward {
		display: flex;
		padding: 24px 0;
	}

	&__elm-backward-link {
		cursor: pointer;
	}

	&__elm-backward-label {
		padding-left: 12px;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 0 12px;
			min-width: 100px;
		}

		&__elm-backward {
			padding: 16px 0;
		}

		&__elm-backward-label {
			padding-left: 0;
			font-size: 18px;
		}
	}
}
</style>
